const IDENTITY_BASE_URL = process.env.REACT_APP_IDENTITY_BASE_URL;

type AuthQueryParamValues = {
  email?: string;
  redirectUrl?: string;
  prompt?: string;
  experience?: string;
};

const buildAuthQueryParams = (
  urlType: 'identity' | 'forums',
  { email, redirectUrl, prompt, experience = 'entry-auth' }: AuthQueryParamValues,
) => {
  const queryParams = [];

  if (email) {
    queryParams.push(`login_hint=${email}`);
  }
  if (experience) {
    // For 'community' experience, don't add the suffix. This is for account switching.
    const applicationValue = experience === 'community' ? 'community' : `community--${experience}`;
    queryParams.push(`application=${applicationValue}`);
  }
  if (redirectUrl) {
    queryParams.push(urlType === 'identity' ? `continue=${redirectUrl}` : `referer=${redirectUrl}`);
  }
  if (prompt) {
    queryParams.push(`prompt=${prompt}`);
  }
  return queryParams;
};

export const getAuthUrl = (type: 'login' | 'signup' | 'logout', queryParamValues: AuthQueryParamValues): string => {
  const queryParams = buildAuthQueryParams('identity', queryParamValues);
  return `${IDENTITY_BASE_URL}/${type}?${queryParams.join('&')}`;
};

export const getForumsSignInUrl = (queryParamValues: AuthQueryParamValues): string => {
  // Only include referer parameter for OAuth2 SSO redirect
  const queryParams = [];
  if (queryParamValues.redirectUrl) {
    queryParams.push(`referer=${queryParamValues.redirectUrl}`);
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return `/forums/s/plugins/common/feature/oauth2sso_v2/sso_login_redirect${queryString}`;
};

export const getForumsSignOutUrl = (khorosEndpointPath: string): string =>
  `forums/s/plugins/custom/atlassian/${khorosEndpointPath}/khoros_logout`;
